import React from "react";

const containerStyle: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
  minHeight: "60vh",
  padding: 32,
  textAlign: "center",
};

const titleStyle: React.CSSProperties = { color: "#7f1d1d", fontSize: 20, marginBottom: 8 };
const bodyStyle: React.CSSProperties = { color: "#7f1d1d", maxWidth: 480 };

export interface PermissionDeniedViewProps {
  reason: "entitlement" | "permission";
  /**
  "team" or "project" - whichever scope the gated route/action checks.
  */
  scopeLabel: "team" | "project";
}

/**
 * Entitlement-locked and permission-denied are rendered with distinct copy on purpose -
 * one is a module/upgrade concern, the other an access/manager concern, and conflating them
 * sends the user to the wrong place for help.
 */
export const PermissionDeniedView: React.FC<PermissionDeniedViewProps> = ({ reason, scopeLabel }) => (
  <div style={containerStyle}>
    <strong style={titleStyle}>{reason === "entitlement" ? "Not available for this deployment" : "Permission denied"}</strong>
    <p style={bodyStyle}>
      {reason === "entitlement"
        ? `This deployment is not entitled to use this page for the current ${scopeLabel}.`
        : `You do not have permission to use this page for the current ${scopeLabel}. Contact a ${scopeLabel} manager to request access.`}
    </p>
  </div>
);
